import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronDown_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.46967 5.46967C2.76256 5.17678 3.23744 5.17678 3.53033 5.46967L10 11.9393L16.4697 5.46967C16.7626 5.17678 17.2374 5.17678 17.5303 5.46967C17.8232 5.76256 17.8232 6.23744 17.5303 6.53033L10.5303 13.5303C10.2374 13.8232 9.76256 13.8232 9.46967 13.5303L2.46967 6.53033C2.17678 6.23744 2.17678 5.76256 2.46967 5.46967Z"
            />
        </SvgStyled>
    );
};

export default ChevronDown_sm;
